export const EMAIL_BUILDER_BLANK_TEMPLATE_NAME = "Blank template";
export const EMAIL_BUILDER_BLANK_TEMPLATE_ILLUSTRATION_SRC =
  "/public/images/emailBuilder/blank-template-illustration.png";

/** Stable id from API EmailDocumentContract::BLANK_HEADER_IMAGE_ID */
export const EMAIL_BUILDER_BLANK_HEADER_IMAGE_BLOCK_ID =
  "dddddddd-dddd-4ddd-8ddd-dddddddddddd";
